import { render, staticRenderFns } from "./vRecipeCategoryPrintout.vue?vue&type=template&id=ff873192&scoped=true"
import script from "./vRecipeCategoryPrintout.vue?vue&type=script&lang=ts"
export * from "./vRecipeCategoryPrintout.vue?vue&type=script&lang=ts"
import style0 from "./vRecipeCategoryPrintout.vue?vue&type=style&index=0&id=ff873192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff873192",
  null
  
)

export default component.exports